<template>
 <v-layout>
   <v-container>
   <v-row>

       <v-dialog v-model="video" max-width="600px">
           <v-card>
               <v-card-title>
                   <span class="headline">Training Video</span>
               </v-card-title>
               <v-card-text>      
                   <v-container>
                       <video id="media-video" width="100%" controls>
                           <source :src="videoUrl" type="video/mp4">
                       </video>
                   </v-container>
               </v-card-text>
           </v-card>
       </v-dialog>
     <v-col cols="12" sm="12" md="12">
      <v-card
        elevation="16"
        outlined
        :disabled="disableEverything"
      >
      <v-card-text>
        <v-container>
          <v-row>
              <v-col cols="3" xm="3" sm="3" md="2">   
          <v-img
                max-height="360"
                max-width="150"
              :src="require('@/assets/logo.png')"
              ></v-img>
            </v-col>
                <v-col cols="6" sm="6" md="6">   
                  <h2>Welcome, {{getUsername}}  </h2>
                  <br>
                  <span>Current Role: {{getRolename}}</span>             
                  <p>Site Code: {{getSiteCode}}</p>
              </v-col>
          </v-row>    
        </v-container>

      </v-card-text>     
      </v-card>
     </v-col>
   </v-row>

   <v-row>
       <v-col cols="4" sm="4" md="4">
           <v-card
                   elevation="16"
                   outlined
           >
               <v-card-text>
                   <v-container>
                       <v-row>
                           <v-col cols="3" xm="3" sm="3" md="2">
                               <v-icon x-large >camera_alt</v-icon>
                           </v-col>
                           <v-col cols="6" sm="6" md="6">
                               <h2>Training Video</h2>
                              <br>  
                              <div v-if="getUserRoleId > 1">
                                   <a  @click="viewVideo()">VIEW CURRENT VIDEO</a>
                                   <!-- <v-btn small color="primary" @click="goUserInstruction()">VIEW CURRENT INSTRUCTIONS</v-btn> -->
                               </div>
                                
                               <div v-if="getUserRoleId > 1">
                                   <v-checkbox
                                           v-model="viewedVideo"
                                           label="I have viewed the training video"
                                           @click="toggleViewVideo()"
                                   >
                                   </v-checkbox>
                               </div>
                               <br>
                               <div v-if="disableEverything">
                                      <p style="color: red;">You must view the training video before proceeding</p>
                               </div>
                               <div v-if="getUserRoleId == 2">
                                   <form id="uploadForm" action='upload_file' role="form" method="post" enctype=multipart/form-data>
                                       <br>
                                       <input type="file" id="videoUploadFile" accept="video/mp4,video/x-m4v,video/*">
                                       <br>
                                       <br>
                                       <v-btn small color="primary" @click="traningVideoUpload()">Upload</v-btn>
                                   </form>
                                   <br>
                               </div>
                             
                           </v-col>
                       </v-row>
                   </v-container>

               </v-card-text>
           </v-card>
       </v-col>
      <v-col cols="4" sm="4" md="4">
      <v-card
        elevation="16"
        outlined
         :disabled="disableEverything"
      >
      <v-card-text>
        <v-container>
          <v-row>
              <v-col cols="3" xm="3" sm="3" md="2">            
                 <v-icon x-large >contact_page</v-icon>
            </v-col>
                <v-col cols="6" sm="6" md="6">   
                  <h2>App instructions</h2>
                  <br>
                <div v-if="getUserRoleId == 2">
                <form id="uploadForm" action='upload_file' role="form" method="post" enctype=multipart/form-data>         
                <br>
                  <input type="file" id="file" name="sampleFile" accept="application/pdf">
                  <br>
                  <br>
                  <v-btn small color="primary" @click="userInstructionUpload()">Upload</v-btn>
                </form>
                <br>
          </div>
                    <a  @click="openResourceFile('userInstruction.pdf')">VIEW CURRENT INSTRUCTIONS</a>
              </v-col>
          </v-row>    
        </v-container>

      </v-card-text>     
      </v-card>
     </v-col>
      <v-col cols="4" sm="4" md="4">
      <v-card
        elevation="16"
        outlined
         :disabled="disableEverything"
      >
      <v-card-text>
        <v-container>
            <v-row>
              <v-col cols="3" xm="3" sm="3" md="2">            
                 <v-icon x-large >stay_current_portrait</v-icon>
            </v-col>
                <v-col cols="6" sm="6" md="6">   
                  <h2>Patient Manual</h2>
                  <br>
                <div v-if="getUserRoleId == 2">
              <form id="uploadForm2" action='upload_file' role="form" method="post" enctype=multipart/form-data>         
              <br>
                <input type="file" id="appFile" name="sampleFile" accept="application/pdf">
                <br>
                <br>
                <v-btn small color="primary" @click="appInstructionUpload()">Upload</v-btn>
              </form>
              <br>
          </div>
                    <a  @click="openResourceFile('appInstruction.pdf')">VIEW CURRENT INSTRUCTIONS</a>
              </v-col>
          </v-row>    
        </v-container>

      </v-card-text>     
      </v-card>
     </v-col>

   </v-row>

      <v-row>
      <!-- <v-col cols="4" sm="4" md="4">
      <v-card
        elevation="16"
        outlined
      >
      <v-card-text>
        <v-container>
          <v-row>
              <v-col cols="3" xm="3" sm="3" md="2">         
                 <v-icon x-large >person_add</v-icon>
            </v-col>
                <v-col cols="6" sm="6" md="6">   
                  <h2>Manage Patient Data </h2>
               <br>
                   <br>    <br>    <br>   
                
                   <br>    <br>
              </v-col>
          </v-row>    
        </v-container>

      </v-card-text>     
      </v-card>
     </v-col> -->

     
   </v-row>
 
   </v-container>



    <div class="text-center">
      <!-- <v-btn dark color="orange darken-2" @click="snackbar = true">Open Snackbar</v-btn> -->
      <v-snackbar v-model="snackbar" :timeout="timeout" color="success" :top="y === 'top'">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
        </template>
      </v-snackbar>
    </div>
 </v-layout>

</template>

<script>
/* eslint-disable no-debugger */
export default {
  name: "Home",
  data: () => ({
    username: "",
    snackbar: false,
    text: "REQUEST COMPLETE",
    timeout: 4000,
    video: false,
    videoUrl: "",
    y: "top",
    disableEverything: false,
  }),
  watch: {
    video(val) {
      if (!val) {
        try {
          var mediaVideo = document.querySelector("#media-video");
          mediaVideo.pause();
        } catch (e) {
          console.error(e);
        }
      }
    },
  },
  mounted() {
    //console.log(this.$store.getters.getRoleId);
    // this.username = this.$store.getters.getUsername;     this.selectedRole = this.roles.find(({ id }) => id == item.roleId);
    var baseUrl = this.$store.getters.getBaseUrl.replace("/api", "");
    this.videoUrl = baseUrl + "training.mp4";
  },
  computed: {
    getUsername() {
      return this.$store.getters.getUsername;
    },
    getRolename() {
      return this.$store.getters.getRoles.find(
        ({ id }) => id == this.$store.getters.getRoleId
      ).name;
    },
    getSiteCode() {
      return this.$store.getters.getSiteCode;
    },
    getUserRoleId() {
      return this.$store.getters.getRoleId;
    },
    viewedVideo: {
      get: function () {
        var returnValue;
        if (this.$store.getters.getViewedVideo == false) {
          returnValue = false;
        } else {
          returnValue = true;
        }
        this.checkToSeeIfWeShouldForceVideoWatch(returnValue);
        return returnValue;
      },
      set: function (newValue) {
        this.$http
          .post(this.$store.getters.getBaseUrl + "markVideoViewed", {
            userId: parseInt(this.$store.getters.getUserId),
            viewedVideo: newValue,
          })
          .then(() => {
            if (newValue == true) {
              this.$store.commit("setMenuAsEnabled");
              this.$store.commit("setViewedVideo", newValue);
            } else {
              this.$store.commit("setMenuAsDisabled");
              this.$store.commit("setViewedVideo", newValue);
            }
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error " + error.response.data);
          });
      },
    },
  },
  methods: {
    toggleViewVideo: function () {
      console.log("TOGGLE VIEW");
    },
    userInstructionUpload: function () {
      //OID40002
      var formData = new FormData();
      var imagefile = document.querySelector("#file");
      formData.append("userInstruction", imagefile.files[0]);
      this.$http
        .post(
          this.$store.getters.getBaseUrl + "userInstructionUpload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          //debugger
          this.snackbar = true;
        })
        .catch(function (error) {
          console.log("error " + error);
          alert("error " + error.response.data);
        });
    },
    appInstructionUpload: function () {
      //OID40002
      debugger;
      var formData = new FormData();
      var imagefile = document.querySelector("#appFile");
      formData.append("appInstruction", imagefile.files[0]);
      this.$http
        .post(
          this.$store.getters.getBaseUrl + "appInstructionUpload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          //debugger
          this.snackbar = true;
        })
        .catch(function (error) {
          console.log("error " + error);
          alert("error " + error.response.data);
        });
    },
    traningVideoUpload: function () {
      //OID40002
      debugger;
      var formData = new FormData();
      var imagefile = document.querySelector("#videoUploadFile");
      formData.append("trainingVideo", imagefile.files[0]);
      this.$http
        .post(
          this.$store.getters.getBaseUrl + "trainingVideoUpload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          //debugger
          this.snackbar = true;
        })
        .catch(function (error) {
          console.log("error " + error);
          alert("error " + error.response.data);
        });
    },
    goUserInstruction: function () {
      const baseUrl = this.$store.getters.getBaseUrl.replace("/api", "");
      window.location.href = baseUrl + "userInstruction.pdf";
    },
    viewVideo: function () {
      console.log("VIEWING VIDEO");
      this.video = true;
    },
    openResourceFile: function (fileName) {
      console.log(fileName);
      const baseUrl = this.$store.getters.getBaseUrl.replace("/api", "");
      // window.location.href = baseUrl + "training.mp4";
      window.open(baseUrl + fileName, "_blank");
    },
    navigateToPatient() {
      this.$router.push({ path: "patient" });
    },
    checkToSeeIfWeShouldForceVideoWatch: function (hasUserWatch) {
      if (hasUserWatch == false) {
        if (this.$store.getters.getRoleId > 1) {
          this.$store.commit("setMenuAsDisabled");
          this.disableEverything = true;
        } else {
          this.$store.commit("setMenuAsEnabled");
          this.disableEverything = false;
        }
      } else {
        this.disableEverything = false;
      }
    },
  },
};
</script>
